import React, { useEffect, useState } from "react";
import Nav from "../components/Nav";
import Hero from "../components/Hero";
import EchoMarquee from "../components/Marquee";
import Collections from "../components/Collections";
import ProductGallery from "../components/ProductGallery";
import InteractiveClothing from "../components/InteractiveClothing";
import Manifesto from "../components/Manifesto";
import Footer from "../components/Footer";
import { getProducts, getCollections } from "../lib/api";

export default function Home() {
  const [products, setProducts] = useState([]);
  const [collections, setCollections] = useState([]);

  useEffect(() => {
    getProducts().then(setProducts).catch(() => {});
    getCollections().then(setCollections).catch(() => {});
    // Scroll to hash target when arriving from another route
    if (window.location.hash) {
      const id = window.location.hash.slice(1);
      setTimeout(() => {
        document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });
      }, 600);
    }
  }, []);

  return (
    <div className="grain relative bg-black">
      <Nav />
      <main>
        <Hero />
        <EchoMarquee />
        <Collections collections={collections} />
        {products.length > 0 && <ProductGallery products={products} />}
        {products.length > 0 && <InteractiveClothing products={products} />}
        <Manifesto />
      </main>
      <Footer />
    </div>
  );
}
